import type { ReactNode } from "react";
import { cn } from "../cn";

/* Form field wrapper — label styling follows the discordforge form language
 * (small, bold, uppercase, tracking-wide labels; zinc-400 hint text). */
export interface FieldProps {
    label?: ReactNode;
    htmlFor?: string;
    hint?: ReactNode;
    error?: ReactNode;
    /** Show an orange asterisk for required fields */
    required?: boolean;
    className?: string;
    children: ReactNode;
}

export function Field({ label, htmlFor, hint, error, required, className, children }: FieldProps) {
    return (
        <div className={cn("flex flex-col gap-2", className)}>
            {label && (
                <label
                    htmlFor={htmlFor}
                    className="text-[11px] font-black uppercase tracking-[0.15em] text-zinc-400"
                >
                    {label}
                    {required && <span className="ml-0.5 text-orange-400">*</span>}
                </label>
            )}
            {children}
            {error ? (
                <p className="text-xs font-medium text-red-400">{error}</p>
            ) : hint ? (
                <p className="text-xs text-zinc-500">{hint}</p>
            ) : null}
        </div>
    );
}
